import { render, staticRenderFns } from "./SearchBarContainer.vue?vue&type=template&id=af4fee52&scoped=true"
import script from "./SearchBarContainer.vue?vue&type=script&lang=js"
export * from "./SearchBarContainer.vue?vue&type=script&lang=js"
import style0 from "./SearchBarContainer.vue?vue&type=style&index=0&id=af4fee52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4fee52",
  null
  
)

export default component.exports